import * as net from 'util/Net';

export interface CanvasVersionPreviewResponse {
  signedUrl: string;
  // ISO 8601 timestamp string (`datetime.isoformat()` on the backend).
  expiresAt: string;
  sdkVersion: string;
}

export function getCanvasVersionPreviewUrl(
  canvasVersionId: string,
  filePath: string = 'index.html'
): Promise<CanvasVersionPreviewResponse> {
  return net.postJSONPromise({
    url: `/1/api/canvas-versions/${canvasVersionId}:render`,
    data: {filePath},
  });
}
